import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 29",
    ...t
  },
  /* @__PURE__ */ e.createElement("g", { clipPath: "url(#payment_svg__clip0)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#2BBB36",
      d: "M8.25 20.035A8.333 8.333 0 1120.035 8.249 8.333 8.333 0 018.25 20.035zm2.357-2.358a.833.833 0 001.178 0l4.473-4.472v2.71a.833.833 0 001.661-.011V11.19a.833.833 0 00-.825-.825H12.38a.833.833 0 10-.012 1.662h2.711l-4.472 4.472a.833.833 0 000 1.178z"
    }
  )),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "payment_svg__clip0" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      d: "M14.142 28.284L0 14.142 14.142 0l14.142 14.142-14.142 14.142z"
    }
  )))
), a = l;
export {
  a as default
};
